import { Phone } from 'lucide-react';

interface SMSPreviewProps {
  content: string;
  companyName?: string;
}

// Sample placeholders for preview
const sampleData: Record<string, string> = {
  '{nome}': 'João Silva',
  '{customer_name}': 'João Silva',
  '{valor}': 'R$ 1.250,00',
  '{vencimento}': '15/02/2026',
  '{billing_due_date}': '15/02/2026',
  '{link_pagamento}': 'https://pay.digisend.com.br/abc123',
  '{billing_url}': 'https://pay.digisend.com.br/abc123',
  '{company_name}': 'Digisend',
  '{company_phone}': '(11) 99999-9999',
};

function replacePlaceholders(text: string): string {
  let result = text;
  Object.entries(sampleData).forEach(([key, value]) => {
    result = result.replace(new RegExp(key.replace(/[{}]/g, '\\$&'), 'g'), value);
  });
  return result;
}

export function SMSPreview({ content, companyName = 'Digisend' }: SMSPreviewProps) {
  const previewContent = replacePlaceholders(content);
  const charCount = previewContent.length;
  const smsCount = Math.ceil(charCount / 160) || 1;

  return (
    <div className="bg-muted/30 rounded-xl p-4 max-w-sm mx-auto border">
      {/* Phone header */}
      <div className="flex items-center gap-3 mb-4 pb-3 border-b">
        <div className="w-10 h-10 rounded-full bg-[hsl(var(--basic-100))] flex items-center justify-center">
          <Phone className="w-5 h-5 text-[hsl(var(--basic-500))]" />
        </div>
        <div className="flex-1">
          <p className="font-medium text-sm text-foreground">{companyName}</p>
          <p className="text-xs text-muted-foreground">Mensagem SMS</p>
        </div>
      </div>

      {/* Message bubble */}
      <div className="bg-[hsl(var(--basic-500))] text-white rounded-2xl rounded-bl-sm p-3 text-sm whitespace-pre-wrap leading-relaxed">
        {previewContent || 'Conteúdo da mensagem SMS...'}
      </div>

      {/* Character count */}
      <div className="flex justify-end mt-2 gap-2">
        <span className="text-[10px] text-muted-foreground">
          {charCount}/160 caracteres
        </span>
        {smsCount > 1 && (
          <span className="text-[10px] text-[hsl(var(--careful-500))]">
            ({smsCount} SMS)
          </span>
        )}
      </div>
    </div>
  );
}
